export default () => window.Core.Search.Mode;
